import React from 'react';
import { Route, Redirect } from 'react-router';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { decodeURL } from 'utils/common';
import {
  selectSsrReqRoute,
  selectIsPageNotFound,
} from 'containers/Landing/selectors';
import { getRedirectPathname } from 'utils/translation';

const RouteBuilder = ({
  component: ChildComponent,
  layout: Layout,
  path,
  isPageNotFound = false,
  ...otherProps
}) => {
  const { utmQuery } = decodeURL();

  const getUtmQuery = (inPath) => {
    const hasQueryParams = inPath && inPath.includes('?');
    return utmQuery ? `${hasQueryParams ? '&' : '?'}${utmQuery}` : '';
  };

  if (isPageNotFound) {
    return (
      <Redirect
        to={{
          pathname: '/page-not-found',
          state: { prevPath: location.pathname },
        }}
      />
    );
  }

  const renderedChildComponent = (props) =>
    Layout ? (
      <Layout name={path}>
        <ChildComponent {...props} />
      </Layout>
    ) : (
      <ChildComponent {...props} />
    );
  const { location } = { ...otherProps };
  const routePath = `${path}${getUtmQuery(path)}`;

  const redirectPathname = getRedirectPathname(location.pathname);
  if (redirectPathname) {
    return (
      <Redirect
        to={{
          pathname: redirectPathname,
          search: location.search,
          state: { prevPath: location.pathname + location.search },
        }}
      />
    );
  }

  return (
    <Route {...otherProps} path={routePath} render={renderedChildComponent} />
  );
};

const mapStateToProps = createStructuredSelector({
  ssrReqRoute: selectSsrReqRoute(),
  isPageNotFound: selectIsPageNotFound(),
});

export default connect(mapStateToProps, null)(RouteBuilder);
